
export const randomImage = (arr) => {
    return arr[Math.floor(Math.random()*arr.length)];
}